import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const ExternalLinkIcon: FunctionComponent<IconProps> = ({ size }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size ? size : 24}
    height={size ? size : 24}
    fill='none'
    viewBox='0 0 18 18'
  >
    <path
      fill='currentColor'
      d='M2 18c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 0 16V2C0 1.45.196.979.587.587A1.928 1.928 0 0 1 2 0h6a.97.97 0 0 1 .713.287A.97.97 0 0 1 9 1c0 .283-.096.52-.287.712A.968.968 0 0 1 8 2H2v14h14v-6c0-.283.096-.521.288-.713A.967.967 0 0 1 17 9c.283 0 .52.096.712.287.192.192.288.43.288.713v6c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 16 18H2Zm4-6a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7L14.6 2H12a.965.965 0 0 1-.712-.288A.965.965 0 0 1 11 1c0-.283.096-.521.288-.713A.967.967 0 0 1 12 0h5c.283 0 .52.096.712.287.192.192.288.43.288.713v5c0 .283-.096.52-.288.712A.965.965 0 0 1 17 7a.965.965 0 0 1-.712-.288A.965.965 0 0 1 16 6V3.4l-8.625 8.625a.918.918 0 0 1-.675.275.96.96 0 0 1-.7-.3Z'
    />
  </svg>
)

export default ExternalLinkIcon;
